export const FETCH_GENRES = "FETCH_GENRES";
export const FETCH_GENRE = "FETCH_GENRE";
export const FETCH_PLAYLIST = "FETCH_PLAYLIST";
export const PLAY_TRACK = "PLAY_TRACK";
export const PAUSE_TRACK = "PAUSE_TRACK";
export const REVEAL_TRACK = "REVEAL_TRACK";
export const SELECT_TRACK = "SELECT_TRACK";
export const FETCH_APP_SETTINGS = "FETCH_APP_SETTINGS";
export const UPDATE_APP_SETTINGS = "UPDATE_APP_SETTINGS";
